module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"newClient":"New Client"},"fr":{"newClient":"Nouveau client"}}')
  delete Component.options._Ctor
}
